import useProviderServiceRequests from '@hooks/queries/registry/onboarding/useProviderServiceRequests';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundProviderServiceRequests = () => {
  const { party } = useParties();
  const providerRequests = useProviderServiceRequests();
  const filtered = providerRequests.data?.filter((r) => r.payload.provider === party) || [];
  return filtered || [];
};
